<template>
  <div>
    <ThemesUser></ThemesUser>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ThemesUser from "@/components/admin/theme/forms/tabs/themesUser.vue";

export default {
  name: "userContentRead",
  components: {
    ThemesUser,
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$i18n.t('sidebar.themesMenu') }]);
  },
  metaInfo: {
    title: 'Sujets abordés',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Les sujets abordés de l\'application TellMeGenius.'}
    ]
  }
};
</script>